<template>
    <div class=audio-tour-page>

        <AudioTour :slides="slides"></AudioTour>

        <PageDescription :post="post" />

    </div>
</template>
<script>
import AudioTour from '../components/AudioTour.vue'
import PageDescription from '../components/PageDescription.vue'

export default {
    name : 'AudioTourPage',
    props : {
        post      : Object,
    },
    data() {
        return {
            slides    : [],
        }
    },
    components : {
        AudioTour,
        PageDescription,
    },
    computed : {
        slideShowProps() {
            return {};
        }
    },
    created() {
        for( let slide of this.post.acf.slides ) {
            this.slides.push({
                image : slide.image.sizes.large ,
                title : slide.text              ,
            });
        }
    }
}
</script>